module.exports = __webpack_public_path__ + "976449afd5e899afe3ee3f8aeb1b6854.svg";